import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c38a00e2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c38a00e2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38a00e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c38a00e2')) {
      api.createRecord('c38a00e2', component.options)
    } else {
      api.reload('c38a00e2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c38a00e2&scoped=true", function () {
      api.rerender('c38a00e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P4_Page/EarningRules/index.vue"
export default component.exports